import {
  GET_SUBSCRIBED_DATA_FEEDS,
  GET_UPDATED_DATA_FEEDS,
} from '../../../../../store/actionTypes';

/**
 * action creater to load polygon data.
 * @param result
 * @returns
 */
export const getSubscribedFeedData = (data: any) => ({
  type: GET_SUBSCRIBED_DATA_FEEDS,
  params: data,
});

/**
 * action creater to load polygon data.
 * @param result
 * @returns
 */
export const getUpdatedFeedData = (data: any) => ({
  type: GET_UPDATED_DATA_FEEDS,
  params: data,
});
